import { PostStats } from '../schema-copy/feed-schema';

/** Words per post above which a feed carries whole articles rather than teasers. */
export const FULL_TEXT_WORDS = 120;
/** Words per post above which the articles count as long-form reading. */
export const LONG_FORM_WORDS = 1000;
/** Images per post above which the feed is visibly image-heavy. */
export const IMAGE_FEED_THRESHOLD = 1.5;
/** Videos / audio items per post above which most posts carry one. */
export const MEDIA_FEED_THRESHOLD = 0.5;

/**
 * Content badges for a feed tile, derived from the sync server's approximate per-post averages
 * (RestUserFeed.postStats). Text gets at most one badge; each media kind its own. Empty when the
 * feed has not been analyzed yet or nothing crosses a threshold.
 */
export function postStatsBadges(stats: PostStats | undefined): string[] {
    if (!stats) return [];
    const badges: string[] = [];
    if (stats.words > LONG_FORM_WORDS) badges.push('long-form text');
    else if (stats.words > FULL_TEXT_WORDS) badges.push('full text');
    if (stats.images > IMAGE_FEED_THRESHOLD) badges.push('images');
    if (stats.videos > MEDIA_FEED_THRESHOLD) badges.push('videos');
    if (stats.audios > MEDIA_FEED_THRESHOLD) badges.push('audio');
    return badges;
}
